module.exports = __webpack_public_path__ + "img/unionpay_logo.61ba4cfe.png";